import {
  getDoesZoneHavePreviewZoneAttribute,
  getTriggersByUrlOnObject,
  setOwnedAndOperatedPreviewDataAttributeAndElement,
  store,
  waitForElement,
} from "../shared";
import {
  ContentTypeName,
  IEventLoggerEnum,
  ITriggeredContentByPage,
} from "../types";
import { EventLoggerModule } from "./event-logger";

export const TriggerContentModule = (() => {
  const updateDomElement = (triggerContent: ITriggeredContentByPage) => {
    const {
      behaviorId,
      content,
      contentType,
      pageShortCode,
      triggerId,
      zoneShortCode,
      zoneName,
    } = triggerContent;

    const selector = `[data-zone-short-code="${zoneShortCode}"]${
      pageShortCode ? `[data-page-short-code="${pageShortCode || ""}"]` : ""
    }`;

    const callBack = (element?: HTMLElement) => {
      const isPreviewZonesMode = store.get("isPreviewZonesMode");

      if (element && content && contentType) {
        const shouldHideZone = content.hideZone;
        const shouldUnhideZoneBeforeSettingContent =
          element.dataset["bcHidden"] === "true";

        try {
          if (shouldHideZone) {
            element.setAttribute("data-bc-hidden", "true");
          } else {
            if (shouldUnhideZoneBeforeSettingContent) {
              element.setAttribute("data-bc-hidden", "false");
            }

            if (contentType === ContentTypeName.Text) {
              if (isPreviewZonesMode) {
                const doesZoneHavePreviewZoneAttribute =
                  getDoesZoneHavePreviewZoneAttribute(element);

                if (doesZoneHavePreviewZoneAttribute) {
                  element.replaceChildren();

                  /*
                Preview tab gets overwritten when we are injecting html into the zone.
                It needs to be added back in as the first child
              */

                  if (doesZoneHavePreviewZoneAttribute) {
                    setOwnedAndOperatedPreviewDataAttributeAndElement({
                      element,
                      contentTypeName: contentType,
                      zoneName,
                    });
                  }
                }
              }

              const textContent = content.text;

              if (textContent) {
                if (isPreviewZonesMode) {
                  element.insertAdjacentHTML("beforeend", textContent);
                } else {
                  element.innerHTML = textContent;
                }
              }
            }
            if (contentType === ContentTypeName.Image) {
              let imageElement: HTMLImageElement | null = null;

              const isZoneElementImage = element.nodeName === "IMG";

              if (isZoneElementImage) {
                imageElement = element as HTMLImageElement;
              } else {
                let possibleChildImageElement =
                  element.querySelector(`:scope img`);

                if (possibleChildImageElement?.nodeName === "IMG") {
                  imageElement = possibleChildImageElement as HTMLImageElement;
                }
              }

              if (imageElement) {
                const imageAlt = content.imageAltText || "";
                const imageSource = content.imageUrl;

                if (!imageSource) return;

                imageElement.src = imageSource;
                imageElement.alt = imageAlt || "";
                imageElement.setAttribute("data-source", imageSource);
                imageElement.setAttribute("data-uw-rm-ima-original", imageAlt);
              }
            }
          }
        } catch (error) {
          EventLoggerModule.logEvent({
            eventType: IEventLoggerEnum.ContentUpdateFailed,
            message: `Could not set content type ${contentType} to zone ${zoneName} 
            for Trigger Id ${triggerId} Behavior Id ${behaviorId}`,
            payload: {
              error,
              triggerId,
              behaviorId,
            },
          });
        }
      }
    };

    waitForElement(selector, callBack);
  };

  const setPageContent = () => {
    const triggeredContentByPage = store.get("triggeredContentByPage");

    const activatedZoneContentByTriggeredEventId =
      getTriggersByUrlOnObject<ITriggeredContentByPage>(triggeredContentByPage);

    const activatedUniversalContent = store.get("universalTriggeredContent");

    if (activatedUniversalContent.length) {
      activatedUniversalContent.forEach(updateDomElement);
    }

    if (activatedZoneContentByTriggeredEventId) {
      if (Object.keys(activatedZoneContentByTriggeredEventId || {}).length) {
        Object.values(activatedZoneContentByTriggeredEventId).forEach(
          updateDomElement
        );
      }
    }
  };

  return {
    setPageContent,
  };
})();
